"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FloatingFeedback = exports.CUSTOMIZR_RESOURCE = void 0;

var _react = _interopRequireWildcard(require("react"));

var _environment = require("../environment");

var _reactComponents = require("@cimpress/react-components");

var _emotion = require("emotion");

var _moment = _interopRequireDefault(require("moment"));

var _index = require("../index");

var _IconClose = _interopRequireDefault(require("@cimpress-technology/react-streamline-icons/lib/IconClose"));

var _IconCheckCircleAlt = _interopRequireDefault(require("@cimpress-technology/react-streamline-icons/lib/IconCheckCircleAlt"));

var _i18n = require("../locales/i18n");

var _trackingService = require("../apis/trackingService");

var _mixpanel = require("./internal/mixpanel");

var _feedbackService = require("../apis/feedbackService");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const CUSTOMIZR_RESOURCE = 'urn:feedback:tracking';
exports.CUSTOMIZR_RESOURCE = CUSTOMIZR_RESOURCE;

const renderThankYou = (tt, showX) => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _emotion.cx)('ctrf-floatBox-container', {
      active: showX
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ctrf-floatBox-flex-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ctrf-floatBox-flex-child",
    style: {
      marginRight: '10px'
    }
  }, /*#__PURE__*/_react.default.createElement(_IconCheckCircleAlt.default, {
    size: '2x',
    color: _reactComponents.colors.success.base,
    weight: 'fill'
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ctrf-floatBox-flex-child-grow"
  }, /*#__PURE__*/_react.default.createElement("h4", null, tt('floatingFeedback.thank_you')))));
};

const getSubmitHandler = (setShowQuestion, setShowThankYou, responses, mainProps) => {
  return async data => {
    setShowQuestion(false);
    setTimeout(() => {
      setShowThankYou(true);
      setTimeout(() => {
        setShowThankYou(false);
      }, 2000);
    }, 500);

    if (!responses.responses) {
      responses.responses = [];
    }

    if (mainProps.accessToken || mainProps.sessionId) {
      await (0, _trackingService.trackAnswer)(mainProps.accessToken || '', responses, mainProps.campaignId, mainProps.questionId || '', data, mainProps.sessionId);
    }
  };
};

const shouldShowBox = (data, campaignId, questionId, silentPeriodInDaysAfterResponse, silentPeriodInDaysAfterClosure) => {
  if (!data) {
    return true;
  }

  const resp = (data.responses || []).find(r => r.campaignId === campaignId && r.questionId === questionId);

  if (!resp) {
    return true;
  }

  const answers = (resp.answers || []).slice();

  if (answers.length === 0) {
    return true;
  }

  answers.sort((a, b) => -1 * a.dateTime.localeCompare(b.dateTime));
  const latestFeedback = answers[0];
  const silentPeriod = latestFeedback.meta ? silentPeriodInDaysAfterResponse : silentPeriodInDaysAfterClosure;
  const silentPeriodStart = (0, _moment.default)().clone().subtract(silentPeriod, 'days').startOf('day');
  return (0, _moment.default)(answers[0].dateTime).isBefore(silentPeriodStart);
};

// eslint-disable-next-line sonarjs/cognitive-complexity,complexity,max-lines-per-function
const FloatingFeedback = props => {
  var _campaignAndQuestions, _campaignAndQuestions2, _campaignAndQuestions3;

  const {
    campaignId,
    questionId,
    accessToken,
    sessionId
  } = props;
  const [showThankYou, setShowThankYou] = (0, _react.useState)(false);
  const [showQuestion, setShowQuestion] = (0, _react.useState)(false);
  const [campaignAndQuestionsInfo, setCampaignAndQuestionsInfo] = (0, _react.useState)(undefined);
  const [responses, setResponses] = (0, _react.useState)({
    responses: []
  });
  const {
    tt
  } = (0, _i18n.useDoubleTTranslation)(props.language); // eslint-disable-next-line sonarjs/cognitive-complexity

  (0, _react.useEffect)(() => {
    if (!accessToken && !sessionId) {
      return;
    }

    (0, _trackingService.getTrackedResponses)(accessToken || '', sessionId).then(data => {
      const userResponses = data || {
        responses: []
      };
      setResponses(responses);
      const shouldShow = shouldShowBox(userResponses, campaignId, questionId, props.silentPeriodInDaysAfterResponse, props.silentPeriodInDaysAfterClosure);

      if (shouldShow) {
        setTimeout(() => {
          setShowQuestion(true);
        }, 1000);
      }
    }).catch(() => {// ignore this.
    });
  }, [accessToken, campaignId, questionId, sessionId]); // const { campaign, questions } = useCampaignAndQuestions(accessToken, props.environment ?? ProductionEnvironment, campaignId, questionId);

  let dialogActive = !!campaignAndQuestionsInfo && !!campaignAndQuestionsInfo.campaign && !!campaignAndQuestionsInfo.questions;

  if (!showQuestion || (campaignAndQuestionsInfo === null || campaignAndQuestionsInfo === void 0 ? void 0 : (_campaignAndQuestions = campaignAndQuestionsInfo.campaign) === null || _campaignAndQuestions === void 0 ? void 0 : _campaignAndQuestions.status) === _feedbackService.CampaignStatus.Suspended || (campaignAndQuestionsInfo === null || campaignAndQuestionsInfo === void 0 ? void 0 : (_campaignAndQuestions2 = campaignAndQuestionsInfo.campaign) === null || _campaignAndQuestions2 === void 0 ? void 0 : _campaignAndQuestions2.endDate) && (0, _moment.default)().isAfter((0, _moment.default)(campaignAndQuestionsInfo === null || campaignAndQuestionsInfo === void 0 ? void 0 : (_campaignAndQuestions3 = campaignAndQuestionsInfo.campaign) === null || _campaignAndQuestions3 === void 0 ? void 0 : _campaignAndQuestions3.endDate))) {
    dialogActive = false;
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderThankYou(tt, showThankYou), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _emotion.cx)('ctrf-floatBox-container', {
      active: dialogActive
    })
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.FlexBox, {
    spaceBetween: true,
    center: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ctrf-floatBox-flex-child-grow"
  }, props.showTitle ? /*#__PURE__*/_react.default.createElement("h6", null, props.boxCaption === 'auto' ? tt('floatingFeedback.caption') : props.boxCaption) : null), /*#__PURE__*/_react.default.createElement("div", {
    className: 'ctrf-floatBox-close'
  }, props.showCloseButton ? /*#__PURE__*/_react.default.createElement(_IconClose.default, {
    color: _reactComponents.colors.info.base,
    weight: "fill",
    onClick: async () => {
      setShowQuestion(false);

      if (props.onClose) {
        props.onClose();
      }

      (0, _mixpanel.mxReportFeedback)(props, campaignAndQuestionsInfo === null || campaignAndQuestionsInfo === void 0 ? void 0 : campaignAndQuestionsInfo.campaign, ((campaignAndQuestionsInfo === null || campaignAndQuestionsInfo === void 0 ? void 0 : campaignAndQuestionsInfo.questions) || [])[0], false, true);
      await (0, _trackingService.trackClosure)(accessToken || '', responses, campaignId, questionId || '', sessionId);
    }
  }) : null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "ctrf-floatBox-content"
  }, /*#__PURE__*/_react.default.createElement(_index.InlineFeedback, _extends({}, props, {
    showThankYouPopover: false,
    onSubmitted: getSubmitHandler(setShowQuestion, setShowThankYou, responses, props),
    onLoaded: (campaignData, questionsData) => {
      setCampaignAndQuestionsInfo({
        campaign: campaignData,
        questions: questionsData
      });
    }
  })))));
};

exports.FloatingFeedback = FloatingFeedback;
FloatingFeedback.defaultProps = {
  language: 'en',
  environment: _environment.ProductionEnvironment,
  showTitle: true,
  showThankYouPopover: false,
  showCloseButton: true,
  boxCaption: 'auto',
  silentPeriodInDaysAfterResponse: 14,
  silentPeriodInDaysAfterClosure: 2
};